module.exports = __webpack_public_path__ + "img/1481243122.8f6ce910.jpg";